<template>
  <div class="careersList">
    <top-header></top-header>
    <b-container style="margin-top: 5%;margin-bottom:4%;">
      <b-row>
        <b-col class="px-3 text-left">
          <div class="heading">Career Opportunities</div>
        </b-col>
      </b-row>
    </b-container>
	
	 <b-container class="mt-5">
		 <b-row>
			<b-col lg="6" md="12" sm="12">
				<b-row class="pb-4" v-for="(item, index) in careersList" :key="index">
					<b-col>
						<div class="department-heading">
							<h4 id="accounting-and-finance">{{item.job_subtitle}}</h4>
						</div>
						<h4 class="list-group-item-heading">
                                    <a :href="'/careers/apply/'+item.job_id">
                                        {{item.job_title}}                              </a>
                                </h4>
						<ul class="list-inline list-group-item-text">
						<li><i class="fa fa-map-marker"></i>  {{item.location}}   </li>
						<li><i class="fa fa-sitemap"></i> {{item.education}}</li>
						</ul>
						
					
					</b-col>
				</b-row>
				
			</b-col>
			<b-col lg="6" md="12" sm="12">
					<p class="pclass mt-0 imageBanner">
									<!-- style="width: 100%; height: 140px;" -->
					<b-img src="https://www.alluraa.com/media/banners/alluraa-careers.jpg" ></b-img><br />
					</p>
					<p class="pclass " style="margin-top: 22px;">
						<span class="spanclass"><strong>Alluraa.com</strong> The Social eCommerce Platform. Trained {{$root.INFLUENCER_TEXT}} assist buyers in making the right choices in the crowd.</span></p>

						<p class="pclass"><span class="spanclass"><strong>Alluraa.com</strong> is a unique platform which combines the best of assisted selling and carefully curated selection of high-quality products with the power of social interaction that connects customers across the country with well-known and upcoming brands.</span></p>

  
			</b-col>
		</b-row>
	</b-container>
    <bottom-footer></bottom-footer>
    
  </div>
</template>

<script>

import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import '../assets/careers.scss';

export default {
  name: "Careers",
  components: {
    "top-header": Header,
    "bottom-footer": Footer,
  },
  beforeCreate: function() {
      document.body.className = 'promo';
  },
  mounted(){
		this.init();
	},
  data() {
    return {
	  recordUrl: this.$root.WEBAPI+'webapi/getCarearlist',
	  careersList:[],
      form_alert: [],
      terms_condition: 'not_accepted',
      modal: {
        msg: ''
      },
      TYPE_SELLER: 'seller',
      TYPE_ADVICER: 'sales-advisor',
      customer:{
        prefix: 'mr',
        role: 'seller',
        fullname: '',
        mobile: '',
        email: '',
        location: '',
        workarea: ""
      },
      team:[
        {id:1, img:'', text:'Alluraa is an attempt to make e-commerce more inclusive, progressive, and impactful for everyone and look towards newer avenues for business growth and opportunities that enable people from every stratum to earn an earnest livelihood.'},
        {id:2, img:'', text:'E-commerce today is paving the way for businesses and retailers, but it also has the scope to uplift the ordinary people who dream of having their businesses but lack the investment. Alluraa is a way to realize that dream, to enable the common man by leveraging technology and innovation.'}
      ],
      states: ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Andaman and Nicobar Islands','Chandigarh','Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry'],
      workarea_salesadvisor: ['Self Employed','Sales & Marketing','Advertising','Logistics','Hospitality','Financial Service','Other'],
      workarea_seller: ['Cosmetics','Electronics','Fashion','Herbal Products','Organic Food','Toys & baby','Other'],
      workarea_options: [],
      mainProps: { blank: true, blankColor: '#b7b7b7', width: 400, height: 110, fluidGrow: true, class: 'm1' },
      iconImg: { width: 100, height: 100, fluidGrow: true, class: 'icon' },
      socialImg: { blank: true, blankColor: '#b7b7b7', width: 300, height: 300, fluidGrow: true, class: 'm1' },
      swiperOption: {
        direction: 'horizontal',
        initialSlide: 0,
        slidesPerGroup: 1,
        loop: false,
        watchSlidesVisibility: true,
        loopFillGroupWithBlank: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 50
            },
            960: {
                slidesPerView: 2,
                spaceBetween: 50
            },
            1124: {
                slidesPerView: 2,
                spaceBetween: 150
            }
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        on: {
            init: function () {
                console.log('swiper initialized');
            },
            slideChange: function() {
                console.log('slide changed');
            }
        },
        fadeEffect: {
            crossFade: true
        },
      }
    }
  },
  methods: {
    init(){
	
		var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.careersList = response.data.result.careersList;
					
					//self.filterChildCategory(0, 0, 0);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
      
    },
    validateemail(email){
      var atposition=email.indexOf("@");  
      var dotposition=email.lastIndexOf(".");  
      if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){ 
        return false;  
      }else{
        return true;
      }
    },
  },
  metaInfo() {
		return{
			title: 'Careers | Alluraa',
			titleTemplate: null,
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'csareers alluraa' },
				{ name: 'description', content: 'careers alluraa' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
				
			]
		}
	}
};
</script>
<style    lang="scss">
   
	
		

</style>
